import { render, staticRenderFns } from "./CompetitionWriteComponent.vue?vue&type=template&id=95ef6646&scoped=true&"
import script from "./CompetitionWriteComponent.vue?vue&type=script&lang=js&"
export * from "./CompetitionWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef6646",
  null
  
)

export default component.exports